export const categoryArticles: Array<{
  slug: string;
  title: string;
  summary: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  views: number;
  comments: number;
  date: string;
}> = [
  {
    slug: 'dingji-wanghong-beihou-ziben-jiaoyi',
    title: '顶流网红背后资本交易全曝光，千万粉丝账号实为傀儡',
    summary: '某平台粉丝破千万的顶流网红被曝所有内容均由MCN机构操控，真实身份成谜。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20abstract%20ink%20splash%20background%20deep%20red%20and%20black%20tones%20mysterious%20atmosphere%20entertainment%20gossip%20portal%20style%20artistic%20blur%20effect%20high%20contrast%20moody%20and%20intense&width=640&height=400&seq=cat-art-01&orientation=landscape',
    views: 128390,
    comments: 3456,
    date: '2026-07-06',
  },
  {
    slug: 'danghong-nvxing-taoshuilou-jiyi',
    title: '当红女星被曝税务漏洞高达八位数',
    summary: '据知情人士透露，该女星三年内通过阴阳合同累计逃税超过3000万元。',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20red%20abstract%20artistic%20background%20flowing%20ink%20texture%20dramatic%20lighting%20entertainment%20news%20visual%20style%20sophisticated%20and%20mysterious%20mood&width=640&height=400&seq=cat-art-02&orientation=landscape',
    views: 98520,
    comments: 2891,
    date: '2026-07-05',
  },
  {
    slug: 'zhiming-zhubo-zhibo-jian-bei-jubao',
    title: '知名主播直播带货假货被当场举报',
    summary: '该主播在直播间销售所谓"原单大牌"被职业打假人当场揭穿。',
    category: '直播翻车',
    categorySlug: 'zhibo-fancheshijian',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20abstract%20composition%20crimson%20and%20black%20ink%20wash%20effect%20intense%20contrasting%20tones%20news%20media%20aesthetic&width=640&height=400&seq=cat-art-03&orientation=landscape',
    views: 75680,
    comments: 2134,
    date: '2026-07-04',
  },
  {
    slug: 'ai-huansheng-jishu-bei-yongyu-zaoyao',
    title: 'AI换脸技术被用于造谣明星出轨',
    summary: '背后黑手竟是该明星的前经纪人，因合约纠纷蓄意报复。',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20abstract%20background%20warm%20beige%20and%20dark%20gray%20tones%20subtle%20gradient%20modern%20editorial%20style&width=640&height=400&seq=cat-art-04&orientation=landscape',
    views: 89340,
    comments: 1890,
    date: '2026-07-06',
  },
  {
    slug: 'duan-shipin-wanghong-renshe-bengta',
    title: '短视频网红人设崩塌：所有内容均有编剧',
    summary: '该网红在短视频中塑造的独立女性形象，实际全部由专业编剧团队打造。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20beige%20and%20dark%20gray%20abstract%20gradient%20background%20soft%20atmospheric%20tone%20minimalist%20editorial%20style&width=640&height=400&seq=cat-art-05&orientation=landscape',
    views: 76450,
    comments: 1678,
    date: '2026-07-05',
  },
  {
    slug: 'dingjian-yiren-jieru-daobi-qian-bei',
    title: '顶流艺人被曝借高利贷赌博',
    summary: '欠款金额触目惊心，多位圈内人士证实该艺人确有严重赌博问题。',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Subtle%20warm%20beige%20abstract%20background%20dark%20gray%20gradient%20accents%20clean%20minimalist%20composition&width=640&height=400&seq=cat-art-06&orientation=landscape',
    views: 67230,
    comments: 1456,
    date: '2026-07-05',
  },
  {
    slug: 'zongyi-jie-zuida-heimu-jiekai',
    title: '综艺界最大黑幕揭开：选秀排名全由资本决定',
    summary: '前综艺导演匿名爆料选秀节目的真实运作方式，每一票都有价格。',
    category: '综艺瓜中瓜',
    categorySlug: 'zongyi-guazhonggua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20beige%20and%20dark%20gray%20abstract%20gradient%20soft%20atmospheric%20minimalist%20style%20clean%20editorial%20composition&width=640&height=400&seq=cat-art-07&orientation=landscape',
    views: 59100,
    comments: 1234,
    date: '2026-07-04',
  },
  {
    slug: 'zhiming-zhuchiren-qian-guize-bei-bao',
    title: '知名主持人被曝潜规则女嘉宾',
    summary: '多名受害者联合发声,曝光该主持人在节目录制期间的种种不当行为。',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20gray%20and%20warm%20beige%20abstract%20gradient%20background%20soft%20subtle%20texture%20minimalist%20editorial%20style&width=640&height=400&seq=cat-art-08&orientation=landscape',
    views: 54890,
    comments: 1123,
    date: '2026-07-04',
  },
  {
    slug: 'daihuo-yi-ge-shangpin-weizaomao',
    title: '带货一哥商品实为自己工厂的贴牌货',
    summary: '号称"厂家直供"的低价商品，实际成本和售价之间存在数十倍的利润空间。',
    category: '直播翻车',
    categorySlug: 'zhibo-fancheshijian',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20beige%20abstract%20background%20dark%20gray%20tones%20soft%20gradient%20clean%20editorial%20style&width=640&height=400&seq=cat-art-09&orientation=landscape',
    views: 48320,
    comments: 987,
    date: '2026-07-03',
  },
];

export const articleDetailMap: Record<string, {
  title: string;
  category: string;
  categorySlug: string;
  date: string;
  views: number;
  comments: number;
  author: string;
  summary: string;
  content: string[];
  imageSeq: string;
  imageQuery: string;
}> = {
  'dingji-wanghong-beihou-ziben-jiaoyi': {
    title: '顶流网红背后资本交易全曝光，千万粉丝账号实为傀儡',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    date: '2026-07-06',
    views: 128390,
    comments: 3456,
    author: '深度调查组',
    summary: '某平台粉丝破千万的顶流网红被曝所有内容均由MCN机构操控，真实身份成谜，日入百万背后是精心设计的骗局。本文为你揭开流量时代的惊天黑幕。',
    content: [
      '近日，一则关于某短视频平台千万粉丝级网红的消息在圈内炸开了锅。据多位不愿透露姓名的知情人士爆料，这位在镜头前光鲜亮丽的"顶流网红"，其账号背后的一切内容——从选题、脚本、拍摄到互动回复，全部由MCN机构的专业团队一手操控。',
      '更令人震惊的是，该网红的"真实身份"也成为一个巨大的谜团。有前员工向本报透露："你看到的那个在镜头前说话的人，可能根本不是账号的‘主人’。账号背后有多达6名不同的‘出镜者’，他们根据不同的内容类型轮流上阵，但对外都宣称是同一个人。"',
      '这一爆料的背后，是整个MCN行业"工业化造星"流水线的冰山一角。业内资深人士分析，头部MCN机构已经形成了一套完整的"网红制造"流程：先是市场调研确定人设定位，然后海选合适的出镜人选，接着由专业编剧团队编写"真实日常"，最后由运营团队负责打造互动数据和商业变现。',
      '该网红的日收入据称超过百万元，主要来源于直播打赏和品牌合作。然而，这些收入的大部分都流入了MCN机构的口袋，真正的出镜者只能拿到固定工资加上少量的提成。',
      '目前，此事已在社交媒体上引发广泛讨论。不少粉丝表示"被骗了感情"，也有网友认为这在行业内是公开的秘密。平台方面暂未对此事作出正式回应。本报将持续关注事件进展。',
    ],
    imageSeq: 'article-detail-01',
    imageQuery: 'Dramatic dark abstract ink splash background with deep red and black tones, mysterious atmosphere, wide cinematic composition, entertainment journalism editorial style, high contrast moody artistic aesthetic',
  },
  'danghong-nvxing-taoshuilou-jiyi': {
    title: '当红女星被曝税务漏洞高达八位数，工作室连夜发声明',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    date: '2026-07-05',
    views: 98520,
    comments: 2891,
    author: '财经调查组',
    summary: '据知情人士透露，该女星三年内通过阴阳合同、虚假发票等手段累计逃税超过3000万元。工作室连夜发布声明称"将积极配合调查"。',
    content: [
      '近日，娱乐圈再次爆出税务问题。某当红一线女星被匿名举报存在重大税务违法行为，涉及金额高达数千万元。据接近税务机关的消息人士透露，相关部门已经介入调查。',
      '举报材料显示，该女星在过去三年间，通过签订"阴阳合同"、虚开发票、以及通过境外壳公司转移收入等多种方式，累计逃避税款超过3000万元人民币。如果最终查实，这将是近年来娱乐圈又一重大税务案件。',
      '值得注意的是，该女星此前一直以"正能量"形象示人，频繁参与各类公益活动，商业代言更是接到手软。业内人士估算，仅2025年一年，其各项收入总和就超过1.5亿元。',
      '事件曝光后，该女星的工作室在深夜紧急发布声明，称"相关报道与事实存在出入"，表示"将积极配合有关部门的调查工作，以正视听"。但声明中并未直接否认逃税指控。',
      '这起事件再次引发公众对娱乐圈税务问题的关注。自前几年某知名艺人因税务问题被重罚后，业内曾进行过一轮自查自纠，但显然仍有漏网之鱼。法律界人士指出，如果逃税金额达到3000万元，当事人可能面临3年以上7年以下有期徒刑。',
    ],
    imageSeq: 'article-detail-02',
    imageQuery: 'Dark red abstract artistic background with flowing ink texture, dramatic lighting, sophisticated mysterious mood, wide cinematic composition, high-end editorial journalism aesthetic',
  },
  'ai-huansheng-jishu-bei-yongyu-zaoyao': {
    title: 'AI换脸技术被用于造谣明星出轨，幕后黑手竟是前经纪人',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    date: '2026-07-06',
    views: 89340,
    comments: 1890,
    author: '科技调查组',
    summary: '背后黑手竟是该明星的前经纪人，因合约纠纷蓄意报复。AI换脸技术的滥用正成为娱乐圈新的安全隐患。',
    content: [
      '近日，一起利用AI换脸技术造谣明星出轨的案件引发社会广泛关注。据警方通报，某当红男星被人在社交媒体上发布所谓的"出轨视频"，经技术鉴定证实该视频系通过AI换脸技术伪造。',
      '更令人震惊的是，警方经过深入调查后发现，幕后操纵者竟是该男星的前经纪人张某。张某此前因合同违约纠纷与该男星对簿公堂，被法院判决赔偿800万元违约金。为泄私愤，张某花费数万元购买了专业的AI换脸软件，用几个月时间精心制作了这批伪造内容。',
      '目前，张某已被警方依法刑事拘留。法律专家指出，利用AI技术伪造他人影像并散布虚假信息，涉嫌侵犯他人肖像权、名誉权，情节严重的还可能构成诽谤罪。此案也是国内首起利用AI换脸技术针对明星的刑事犯罪案件，具有重大警示意义。',
      '随着AI技术的快速发展，换脸技术已经变得越来越容易获取。专业人士呼吁相关部门尽快出台针对AI换脸技术的使用规范，防止更多无辜者受到伤害。平台方也表示将加大对AI伪造内容的检测力度，保护用户和公众人物的合法权益。',
    ],
    imageSeq: 'article-detail-04',
    imageQuery: 'Dark abstract technology themed background with circuit patterns and digital distortion effects, deep red and black tones, futuristic AI visualization, mysterious atmosphere, cinematic editorial style',
  },
  'duan-shipin-wanghong-bei-bao-xiedu-juben': {
    title: '短视频网红被曝所有内容均有编剧团队，真实人设彻底崩塌',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    date: '2026-07-05',
    views: 76450,
    comments: 1678,
    author: '深度调查组',
    summary: '该网红在短视频中塑造的独立女性形象，实际全部由专业编剧团队打造，包括每一句台词和每一个表情。',
    content: [
      '近日，一则关于短视频网红"独立女性人设"造假的爆料在全网疯传。据该网红前工作室员工透露，该网红在短视频平台发布的所有内容，从选题策划、脚本撰写、场景布置到台词设计，全部由一支多达15人的专业编剧团队包办。',
      '更令人咋舌的是，该网红在视频中展现的"亲自下厨""独自旅行""创业故事"等场景，均有详细的拍摄脚本和分镜设计。据泄露的内部文件显示，一段看似随意的"日常vlog"实际包含了长达20页的脚本和详细的镜头表，每一个表情和动作都经过精心排练。',
      '前员工还透露，该网红现实中与视频中展现的"独立、自律、正能量"形象截然相反，日常生活中的行为举止与镜头前判若两人。该爆料一经发布，该网红的粉丝数在短时间内暴跌超过200万。',
      '目前，该网红尚未对此事作出正面回应。但有细心的网友发现，其工作室已经开始大规模删除此前发布的视频内容。业内分析人士指出，这种人设崩塌事件在短视频行业并非个例，"工业化造人设"已经成为许多头部MCN机构的标配操作流程。',
    ],
    imageSeq: 'article-detail-05',
    imageQuery: 'Dramatic dark abstract background with torn paper and fragmented text elements, deep crimson and black tones, concept of deception and facade, moody cinematic atmosphere, editorial news style',
  },
  'dingjian-yiren-jieru-daobi-qian-bei': {
    title: '顶流艺人被曝借高利贷赌博，欠款金额触目惊心',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    date: '2026-07-05',
    views: 67230,
    comments: 1456,
    author: '财经调查组',
    summary: '欠款金额触目惊心，多位圈内人士证实该艺人确有严重赌博问题，目前已被多个债权人追讨。',
    content: [
      '据多位圈内人士透露，某顶流男艺人近年来深陷赌博泥潭，欠下巨额债务。知情人士称，该艺人曾在澳门、拉斯维加斯等多地的高档赌场一掷千金，单次下注金额高达数百万元。',
      '据债权人之一披露，该艺人自2024年起开始向其借款，最初以"投资""周转"等名义借款数百万元。之后债务雪球越滚越大，目前累计欠款已超过5000万元。该债权人还表示，艺人方面曾多次承诺还款，但至今仅归还了不到10%的借款。',
      '更令人震惊的是，该艺人还被曝出曾向高利贷机构借款。据一份流出的借款协议显示，该艺人以月息15%的超高利率借款2000万元，用于偿还此前的赌债。按照该利率计算，仅利息一项每月就需要支付300万元。',
      '事件曝光后，与该艺人合作的品牌方纷纷发表声明表示"正在评估合作关系"。该艺人的经纪公司也在第一时间发布声明称"正在核实相关情况"，但并未直接否认指控。法律界人士指出，如果艺人确实存在赌博行为，可能违反其代言合同中的"道德条款"，面临巨额违约金索赔。',
    ],
    imageSeq: 'article-detail-06',
    imageQuery: 'Dramatic dark abstract composition with shadowy silhouettes and gambling chips imagery, deep red and black tones, mysterious dangerous atmosphere, cinematic editorial photography style',
  },
  'zongyi-jie-zuida-heimu-jiekai': {
    title: '综艺界最大黑幕揭开：选秀排名全由资本决定',
    category: '综艺瓜中瓜',
    categorySlug: 'zongyi-guazhonggua',
    date: '2026-07-04',
    views: 59100,
    comments: 1234,
    author: '深度调查组',
    summary: '前综艺导演匿名爆料选秀节目的真实运作方式，每一票都有价格，冠军内定早已是公开的秘密。',
    content: [
      '近日，一位曾在某头部卫视担任综艺节目导演长达8年的业内人士化名"老导演"，通过每日黑料独家爆料了国内选秀节目的真实运作方式。他声称，近年来火爆全网的选秀节目，其最终结果在开播前就已经被"内定"。',
      '据"老导演"透露，选秀节目的排名实际上由多方资本博弈决定。选手所属的经纪公司、赞助品牌方以及平台方之间会进行多轮谈判，最终形成一个"利益最大化"的排名方案。每一个环节都有明确的价格标签——初舞台的镜头时长、导师的点评措辞、观众投票的结果，都可能被资本操控。',
      '"你以为粉丝拼命打投真的能改变排名吗？那只是让观众有参与感的障眼法而已。"老导演在爆料中直言不讳，"最终的出道名单在开赛前三个月就已经确定了，粉丝的钱只不过是给节目制作方和平台方增加收入而已。"',
      '这一爆料在娱乐圈和粉丝群体中引发轩然大波。多位选秀节目出身的艺人经纪人表示，虽然知道选秀有"剧本"，但没想到内幕如此黑暗。粉丝们则在社交媒体上发起了"还我们真实投票"的话题讨论，呼吁有关部门介入调查。目前，已有部分选秀节目的赞助商宣布终止合作关系。',
    ],
    imageSeq: 'article-detail-07',
    imageQuery: 'Dark abstract composition with stage curtains and spotlight elements, deep red and black dramatic tones, entertainment industry backstage atmosphere, cinematic editorial style, mysterious mood',
  },
  'zhiming-zhuchiren-qian-guize-bei-bao': {
    title: '知名主持人被曝潜规则女嘉宾，多名受害者联合发声',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    date: '2026-07-04',
    views: 54890,
    comments: 1123,
    author: '深度调查组',
    summary: '多名受害者联合发声，曝光该主持人在节目录制期间的种种不当行为，已有超过10名女性站出来指证。',
    content: [
      '近日，一则关于某卫视知名主持人的重磅爆料持续发酵。截至目前，已有超过10名女性勇敢站出来，指证该主持人在节目录制期间存在长期的不当行为。',
      '据其中一位受害者透露，该主持人在节目录制间隙多次以"交流主持技巧""单独对稿"等名义将年轻女嘉宾或女工作人员单独叫到化妆间或休息室。在这些场合，该主持人会做出不同程度的越界行为，包括言语骚扰和身体接触。',
      '更令人发指的是，据多名受害者联合声明，该主持人存在系统性的行为模式——他会先对新来的工作人员示好，给予特别关照，建立信任关系后再逐步试探底线。对于顺从的对象，他会承诺"更多出镜机会""更好的节目资源"；对于反抗的对象，则会以各种方式排挤打压。',
      '目前，该主持人的所属电视台已发布声明表示"高度重视，正在核实相关情况"，并已暂停其所有节目录制工作。法律界人士指出，如果相关指控属实，该主持人不仅面临事业终结，还可能因性骚扰、强制猥亵等罪名承担刑事责任。警方表示已收到相关报案，正在展开调查。',
    ],
    imageSeq: 'article-detail-08',
    imageQuery: 'Dark abstract background with silhouettes of conflict and confrontation, deep red and black moody tones, emotional dramatic atmosphere, cinematic editorial photography style for breaking news',
  },
  'daihuo-yi-ge-shangpin-weizaomao': {
    title: '带货一哥被曝商品实为自己工厂产的贴牌货',
    category: '直播翻车',
    categorySlug: 'zhibo-fancheshijian',
    date: '2026-07-03',
    views: 48320,
    comments: 987,
    author: '消费维权组',
    summary: '号称"厂家直供"的低价商品，实际成本和售价之间存在数十倍的利润空间，消费者纷纷要求退款。',
    content: [
      '近日，号称"全网最低价""厂家直供"的某带货一哥被曝出惊天黑幕。据内部人士向每日黑料爆料，该主播直播间销售的多款商品，实际来自其自有的代工厂，所谓的"大牌同厂""原单正品"纯属虚假宣传。',
      '据泄露的成本明细表显示，一款在直播间售价299元的"进口大牌平替"护肤品，实际生产成本仅为8元；一款售价199元的"意大利设计师款"包包，实际生产地就在广东某小作坊，成本不超过20元。这些商品的毛利润率高达3000%以上。',
      '更令人愤怒的是，该主播在直播间反复强调"这个价格我是在贴钱做福利""我只赚一块钱"等话术，配合看似真诚的表演，让不少粉丝信以为真。一位购买了近万元的消费者在接受采访时表示："我觉得我们被骗了，他就是利用我们对他的信任来赚钱。"',
      '事件曝光后，相关商品的退货率在短短两天内飙升至85%。市场监管部门表示已注意到此事，正在对涉事商品进行质量检测，若发现质量问题或虚假宣传行为，将依法进行处罚。法律界人士提醒消费者，遇到类似情况可保留证据向平台投诉，情节严重的可向市场监管部门举报。',
    ],
    imageSeq: 'article-detail-09',
    imageQuery: 'Dark abstract composition with broken shopping bag and price tag elements, deep red and black tones, consumer fraud concept atmosphere, cinematic editorial style for investigative journalism',
  },
};